import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
  IconButton,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';

export default function HtmlDisplay() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Get data from navigation state - updated to match the provided code structure
  const { imageUrl, json, transactionId, ticketId, htmlData } = location.state || {};

  useEffect(() => {
    if (imageUrl) {
      setLoading(false);
    } else if (htmlData?.demo) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [imageUrl, htmlData]);

  const handleBack = () => {
    navigate('/transactions');
  };

  const handleClose = () => {
    navigate('/transactions');
  };

  if (!location.state) {
    return (
      <Box sx={{ background: "white", minHeight: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            No data available. Please go back and try again.
          </Alert>
          <Button variant="contained" onClick={handleBack}>
            Go Back
          </Button>
        </Box>
      </Box>
    );
  }

  if (loading) {
    return (
      <Box sx={{ background: "white", minHeight: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ background: "white", minHeight: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
          <Button variant="contained" onClick={handleBack}>
            Go Back
          </Button>
        </Box>
      </Box>
    );
  }

  // If no imageUrl is available, show error
  if (!imageUrl && !htmlData?.demo) {
    return (
      <Box sx={{ background: "white", minHeight: "100vh", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Box sx={{ textAlign: 'center' }}>
          <Alert severity="error" sx={{ mb: 2 }}>
            No image available. Please try submitting a ticket again.
          </Alert>
          <Button variant="contained" onClick={handleBack}>
            Go Back
          </Button>
        </Box>
      </Box>
    );
  }

  // Use the imageUrl from the API response, or fallback to demo URL
  const displayUrl = imageUrl || 'http://34.150.235.190:8000/static/data/cspf_map_25161.html';

  return (
    <Box sx={{ 
      background: "white", 
      width: '100vw', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column'
    }} className="html-display-page">
      {/* Minimal header with close button */}
      <Box sx={{ 
        position: 'absolute',
        top: 10,
        right: 10,
        zIndex: 10000,
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: 1,
        padding: 0.5
      }}>
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>

      {/* HTML Content */}
      <iframe
        src={displayUrl}
        title={`HTML Content for Ticket ${ticketId}`}
        style={{ 
          border: 'none',
          width: '100%',
          height: '100%',
          flex: 1,
          margin: 0,
          padding: 0,
          overflow: 'hidden'
        }}
        scrolling="no"
        onLoad={() => setLoading(false)}
        onError={() => {
          setLoading(false);
          setError(`Failed to load HTML content`);
        }}
      />
    </Box>
  );
} 